import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_minimalist_bathroom: FaireThemeEntity = {
  token: "discovery_theme_minimalist-bathroom",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Minimalist Bathroom",
  description: "Clean lines and simple bath essentials",
  bgColor: "#E0E8ED",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
